import { InputForm, Error, SubmitButton } from "components";
import {
  DateRangeInput,
  DateRangeInputError,
} from "modules/user_management/dcdd_user/users/state/actionType";

interface Props {
  formData: DateRangeInput;
  error: DateRangeInputError;
  loading: boolean;
  onClose?: () => void;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement >
  ) => void;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
}
const DateRangeForm: React.FC<Props> = ({
  handleChange,
  handleSubmit,
  error,
  formData,
  loading,
}) => {
  return (
    <>
     <form>
  <div className="flex gap-4 items-end">
    <div>
      <InputForm
        label="From Date"
        id="fromDate"
        name="fromDate"
        type="date"
        value={formData.fromDate}
        onChange={handleChange}
      />
      {error.fromDate && <Error>{error.fromDate}</Error>}
    </div>
    <div>
      <InputForm
        label="To Date"
        id="toDate"
        name="toDate"
        type="date"
        value={formData.toDate}
        onChange={handleChange}
      />
      {error.toDate && <Error>{error.toDate}</Error>}
    </div>
    <div className="pb-3">
      <SubmitButton
        onClick={handleSubmit}
        loading={loading}
        loadingText="Searching..."
      >
        Search
      </SubmitButton>
    </div>
  </div>
</form>

    </>
  );
};
export default DateRangeForm;
